import { Navigate, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/tenant-settings/share-governance")({
  component: ShareGovernanceRoutePage,
});

function ShareGovernanceRoutePage() {
  return <Navigate to="/tenant-settings/permissions" replace />;
}
